import { Helmet } from "react-helmet-async";
import { Zap, Layers, BarChart3, Users, Sparkles, HeartHandshake } from "lucide-react";
import TierPageLayout from "@/components/pricing/TierPageLayout";

const StudioTierPage = () => {
  return (
    <>
      <Helmet>
        <title>Studio Plan — $599/Month | Multi-client Google Ads for Small Agencies | Upfixe</title>
        <meta name="description" content="Studio plan: 25 brands, unlimited campaigns, priority founder support. $599/month — agency-economic pricing where the value is speed across many accounts." />
        <meta name="keywords" content="small agency Google Ads, 25 client PPC, multi-client MCC, chat-native agency tool" />
        <meta property="og:title" content="Studio Plan — $599/Month | Multi-client Google Ads for Small Agencies | Upfixe" />
        <meta property="og:description" content="Studio plan: 25 brands, unlimited campaigns, priority founder support. $599/month for small agencies running 10–25 clients." />
        <link rel="canonical" href="https://upfixe.com/plans/studio" />
      </Helmet>
      <TierPageLayout
      tierName="Studio"
      tagline="STUDIO PLAN"
      headline="Build campaigns across 25 clients without a 6-person team"
      subheadline="For small agencies running 10–25 active clients. $24 per brand per month. Add a new client in chat, ship the first campaign before the kickoff call is over."
      price={599}
      priceNote="Billed monthly · 7-day free trial · or $5,990/yr"
      bestFor="Small agencies & studios"
      audienceDescription="The tier that funds your roster. At 25 brands, your per-client overhead drops below what you can profitably manage manually — Upfixe pays for itself before lunch on day one."
      features={[
        {
          icon: <Layers className="h-5 w-5" />,
          title: "25 brands, fully isolated",
          description: "Each client lives in its own brand — separate value-prop doc, separate Google Ads sub-account, separate reporting."
        },
        {
          icon: <Users className="h-5 w-5" />,
          title: "MCC-first workflow",
          description: "Sit on top of your manager account. New client onboarding is one OAuth screen and a homepage URL."
        },
        {
          icon: <Zap className="h-5 w-5" />,
          title: "Unlimited campaigns, period",
          description: "No per-brand or per-account caps. Build as many search campaigns as your clients need."
        },
        {
          icon: <BarChart3 className="h-5 w-5" />,
          title: "Cross-client roll-up reporting",
          description: "\"How's the whole book doing this month?\" One question, one answer — across all 25 brands."
        },
        {
          icon: <Sparkles className="h-5 w-5" />,
          title: "Per-brand negative-keyword libraries",
          description: "Each client gets its own ever-growing negatives list — off-vertical, competitor, brand-research — built up over every campaign you ship."
        },
        {
          icon: <HeartHandshake className="h-5 w-5" />,
          title: "Priority founder support",
          description: "Email george@upfixe.com and you get a same-day reply from the person who built this."
        }
      ]}
      limits={[
        "25 brands",
        "Unlimited campaigns",
        "Unlimited reports",
        "MCC + sub-account support",
        "Cross-client roll-up reporting",
        "Priority founder support",
        "All Agency features"
      ]}
      useCases={[
        {
          title: "Small full-service agencies",
          description: "Two to five staff, 10–25 active clients. You need speed and consistency more than headcount."
        },
        {
          title: "Local-services holding operators",
          description: "You own or manage a portfolio of HVAC, plumbing, restoration brands. One tool, every account, one chat."
        },
        {
          title: "Vertical-focused PPC studios",
          description: "Niche specialists serving a defined ICP across many similar accounts. The repetitive parts get faster — the strategy stays yours."
        },
        {
          title: "Marketing-led consultancies",
          description: "Strategy is your product. Campaign execution is overhead. Upfixe collapses the overhead."
        }
      ]}
      ctaText="Start 7-day free trial"
    />
    </>
  );
};

export default StudioTierPage;
